var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 114,
    rx: 57,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5454 53.5453H69.0909V46.6363C69.0909 39.8999 63.7364 34.5454 57 34.5454C50.2636 34.5454 44.9091 39.8999 44.9091 46.6363V53.5453H41.4546V46.6363C41.4546 37.9999 48.3636 31.0908 57 31.0908C65.6364 31.0908 72.5454 37.9999 72.5454 46.6363V53.5453Z",
    fill: "#FF460B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8182 82.9088H43.1818C40.2455 82.9088 38 80.6633 38 77.7269V56.9997C38 54.0633 40.2455 51.8179 43.1818 51.8179H70.8182C73.7546 51.8179 76 54.0633 76 56.9997V77.7269C76 80.6633 73.7546 82.9088 70.8182 82.9088ZM43.1818 55.2724C42.1455 55.2724 41.4546 55.9633 41.4546 56.9997V77.7269C41.4546 78.7633 42.1455 79.4542 43.1818 79.4542H70.8182C71.8546 79.4542 72.5455 78.7633 72.5455 77.7269V56.9997C72.5455 55.9633 71.8546 55.2724 70.8182 55.2724H43.1818Z",
    fill: "#FF460B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65.6361C58.9079 65.6361 60.4546 64.0895 60.4546 62.1816C60.4546 60.2737 58.9079 58.7271 57 58.7271C55.0921 58.7271 53.5455 60.2737 53.5455 62.1816C53.5455 64.0895 55.0921 65.6361 57 65.6361Z",
    fill: "#FF460B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8637 62.1816H56.1364L54.4091 72.5453H59.5909L57.8637 62.1816Z",
    fill: "#FF460B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreLock);
export default __webpack_public_path__ + "static/media/store_lock.b40b6c6a11613d7270d320c63c85dd39.svg";
export { ForwardRef as ReactComponent };